import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";

export default function SectionTitle({ text }) {
  return (
    <Box display="flex" alignItems="center" gap={2}>
      <Typography
        color="secondary"
        component="h2"
        sx={{ fontSize: { xs: "1.2rem", sm: "1.5rem" } }}
        gutterBottom
      >
        {text}
      </Typography>
      <Box sx={{ width: "100%" }}>
        <Divider />
      </Box>
    </Box>
  );
}
